const isObject = (value: unknown): value is object => typeof value === 'object' && value !== null;

export const findErrors = (value: unknown, paths: unknown): Error[] => {
  if (value instanceof Error) {
    return [value];
  }

  if (!isObject(value) || !isObject(paths)) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.flatMap((item) => findErrors(item, paths));
  }

  return Object.entries(paths).flatMap(([key, nestedPaths]) => findErrors(Reflect.get(value, key), nestedPaths));
};
